<div *ngIf="hasErrors" class="form-error is-visible">
  <ng-container *ngFor="let error of (controlFormGroup.controls[this.controlName].errors | keyvalue)">
    <ng-container [ngSwitch]="error.key">
      <ng-container *ngSwitchCase="'server'">
        <div *ngFor="let message of error.value">
          {{ message }}
          <span *ngIf="message === 'A user with this email already exists.'">
            <a routerLink="/auth/login">Click here</a> to log in.
          </span>
        </div>
      </ng-container>
      <div *ngSwitchCase="'required'">
        {{ controlName | controlNameToHuman | titlecase | snakeCaseToHuman }} is required
      </div>
      <div *ngSwitchCase="'minlength'">
        {{ controlName | controlNameToHuman | titlecase | snakeCaseToHuman }} should have at least
        {{ error.value.requiredLength }} {error.value.requiredLength, plural, =0 {characters} =1 {character} other {
        characters }}
      </div>
      <div *ngSwitchCase="'confirm_password'">The passwords must match</div>
      <div *ngSwitchCase="'email'">Email is invalid</div>
      <div *ngSwitchCase="'whitespace'">Label can't be spaces only</div>
      <div *ngSwitchDefault>{{ error.value }}</div>
    </ng-container>
  </ng-container>
</div>
